export function formatCurrency(amount) {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date);
}

export function formatDateShort(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

export function calculateVATBreakdown(items) {
  const breakdown = {};
  
  items.forEach(item => {
    const rate = item.vat_rate.toString();
    if (!breakdown[rate]) {
      breakdown[rate] = { net: 0, vat: 0, gross: 0 };
    }
    breakdown[rate].net += item.total_net;
    breakdown[rate].vat += item.vat_amount;
    breakdown[rate].gross += item.total_gross;
  });
  
  return breakdown;
}

export function downloadFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
